import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "required"
}
const _hoisted_2 = {
  key: 0,
  class: "help"
}
const _hoisted_3 = ["checked"]
const _hoisted_4 = {
  name: "errors",
  class: "invalid-feedback"
}

import { useField } from "vee-validate";
import type { FieldSchema } from "@/models/form";
import { ref, toRefs, onMounted, useSlots, computed, watch } from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import * as yup from "yup";

export default /*@__PURE__*/_defineComponent({
  __name: 'Checkbox',
  props: {
    name: { default: "checkbox" },
    schema: {},
    rules: {},
    modelValue: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {

const inputRef = ref<HTMLInputElement | null>(null);

const props = __props;

const { name, schema } = toRefs(props);

const validationSchema = computed(() => {
  if (props.schema.required) {
    return yup
      .boolean()
      .oneOf([true], schema.value.errorMessage)
      .required(schema.value.errorMessage);
  }

  return yup.boolean().notRequired();
});

const { value, errors, setValue } = useField(name, validationSchema);

const slots = useSlots();

const hasHelpSlot = computed<boolean>(() => {
  return !!slots["help"];
});

onMounted(() => {
  if (props.modelValue) {
    setValue(props.modelValue);
  }
});

__expose({
  errors,
  setValue,
  value,
  inputRef,
});

watch(
  () => props.modelValue,
  () => {
    setValue(props.modelValue);
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("label", _mergeProps(_ctx.$attrs, { class: "checkbox-container" }), [
      _renderSlot(_ctx.$slots, "label", {}, () => [
        _createTextVNode(_toDisplayString(_unref(schema).label ? _unref(schema).label : " ") + " ", 1),
        (_unref(schema).label && _unref(schema).required)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, "*"))
          : _createCommentVNode("", true)
      ]),
      (hasHelpSlot.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_unref(FontAwesomeIcon), { icon: "fas fa-circle-info" }),
            _createElementVNode("div", {
              class: _normalizeClass(["tooltip", _unref(schema).tooltipLocation])
            }, [
              _renderSlot(_ctx.$slots, "help", {}, () => [
                _cache[1] || (_cache[1] = _createTextVNode("Shalom from the tooltip!", -1))
              ])
            ], 2)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("input", _mergeProps(_ctx.$attrs, {
        class: ["form-check-input", {
        'is-invalid': _unref(schema).touched && !_unref(schema).valid,
      }],
        type: "checkbox",
        checked: __props.modelValue,
        onChange: _cache[0] || (_cache[0] = ($event: any) => (
        _ctx.$emit('update:modelValue', ($event.target as HTMLInputElement).checked)
      ))
      }), null, 16, _hoisted_3),
      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "checkmark" }, null, -1))
    ], 16),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(errors), (error) => {
          return (_openBlock(), _createElementBlock("li", { key: error }, _toDisplayString(error), 1))
        }), 128))
      ])
    ])
  ], 64))
}
}

})